<template>
  <div class='h-dialogContainer'>
    <form id='alarmRedirectForm'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}:</div>
          <ejs-dropdownlist :dataSource='alarmLevel.list' :fields='alarmLevel.listFields' v-model='alarmLevel.checkValue'></ejs-dropdownlist>
        </div>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmDec')}}:</div>
          <ejs-textbox name='alarmDec' multiline='true' v-model='description'></ejs-textbox>
        </div>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.advise')}}:</div>
          <ejs-textbox name='advise' multiline='true' v-model='advise'></ejs-textbox>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'alarmRedirect',
  data() {
    return {
      alarmID: '',
      alarmType: 6,
      isRedefned: 0,
      neTypeId: '',
      systemType: '',
      alarmLevel: {
        listFields: { text: 'name', value: 'value' },
        list: [
          { name: this.$t('Alarm.alarmLevel_3'), value: '3' },
          { name: this.$t('Alarm.alarmLevel_2'), value: '2' },
          { name: this.$t('Alarm.alarmLevel_1'), value: '1' },
          { name: this.$t('Alarm.alarmLevel_0'), value: '0' }
        ],
        checkValue: ''
      },
      description: '',
      advise: '',
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          alarmDec: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            maxLength: [127, `${this.$t('Alarm.maxLength')}127`],
            regex: [/^[^'\\]+$/, `${this.$t('Alarm.notSingleQuoteOrBackslash')}`]
          },
          advise: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            maxLength: [127, `${this.$t('Alarm.maxLength')}127`],
            regex: [/^[^'\\]+$/, `${this.$t('Alarm.notSingleQuoteOrBackslash')}`]
          }
        }
      }
    };
  },
  methods: {
    clear() {
      this.alarmID = '';
      this.alarmType = '';
      this.isRedefned = '';
      this.systemType = '';
      this.alarmLevel.checkValue = '';
      this.description = '';
      this.advise = '';
      this.neTypeId = '';
    },
    getdata() {
      if (this.validate()) {
        return {
          alarmID: this.alarmID,
          alarmType: this.alarmType,
          systemType: this.systemType,
          level: parseInt(this.alarmLevel.checkValue, 10),
          description: this.description,
          solution: this.advise,
          neTypeId: this.neTypeId
        };
      }
      return false;
    },
    setAlarmId(data) {
      // 查询数据，显示出来
      this.bindValidate();
      this.alarmID = data[0].alarmID;
      this.alarmType = data[0].alarmType;
      this.systemType = data[0].systemType;
      this.alarmLevel.checkValue = `${data[0].level}`;
      this.description = data[0].description;
      this.advise = data[0].solution;
      this.neTypeId = data[0].neTypeId;
    },
    bindValidate() {
      this.formObj = new FormValidator('#alarmRedirectForm', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>